import React from 'react';

import { Button, ButtonGroup, StandardButton } from '@eika/button';

import { Currency } from '../../../../../generated-types';
import useTranslation from '../../../../../hooks/useTranslation';
import { EikaModal } from '../../../../EikaModal';
import { AmountRangeInput } from '../../AmountRangeInput';
import { useTransactionFilterContext } from '../../TransactionFilterContext/TransactionFilterContext';

type Props = {
    open: boolean;
    onClose: () => void;
    targetCurrency: Currency;
};

const MobileAmountRangeModal: React.FC<Props> = ({ open, onClose, targetCurrency }) => {
    const translation = useTranslation();
    const { minAmount, maxAmount, moneyDirection } = useTransactionFilterContext();
    return (
        <EikaModal contentShouldStretch id="amount-submodal" open={open} setOpen={() => null} onClose={onClose}>
            <section className="modal-content">
                <AmountRangeInput
                    contentWrapperClassName="transaction-filter-form__amount-range-wrapper"
                    mainLabel={translation.transactionFilter.chooseAmount}
                    fromAmount={{
                        value: minAmount.value,
                        onChange: minAmount.set,
                        label: translation.transactionFilter.from,
                        id: 'min-amount',
                        name: 'transaction-filter-min-amount',
                    }}
                    toAmount={{
                        value: maxAmount.value,
                        onChange: maxAmount.set,
                        label: translation.transactionFilter.to,
                        id: 'max-amount',
                        name: 'transaction-filter-max-amount',
                    }}
                    currency={targetCurrency}
                    moneyDirection={moneyDirection}
                />
                <ButtonGroup
                    className="transaction-filter-form__sub-submit-wrapper"
                    primaryAction={
                        <Button type="button" onClick={onClose}>
                            {translation.transactionFilter.choose}
                        </Button>
                    }
                    hideSecondaryAction={typeof minAmount.value !== 'number' && typeof maxAmount.value !== 'number'}
                    secondaryAction={
                        <StandardButton
                            buttonType="negative"
                            onClick={() => {
                                moneyDirection.reset();
                                minAmount.reset();
                                maxAmount.reset();
                            }}
                        >
                            {translation.transactionFilter.removeChosen}
                        </StandardButton>
                    }
                />
            </section>
        </EikaModal>
    );
};

export default MobileAmountRangeModal;
